import { UPPBEAT_MUSIC_TRACKS } from './uppbeat-music.js';
/**
 * Shared music library available to all templates.
 * URLs point to audio files on the CDN (S3 public assets bucket).
 */
// Legacy fallback. V2 creation chooses from the profiled bank.
export const DEFAULT_MUSIC_TRACK_ID = 'tea-pop';
export const SHARED_MUSIC_TRACKS = [
    {
        id: 'tea-pop',
        name: 'Tea Pop',
        path: '/public/audio/tea-pop.mp3',
        duration: 102,
        bpm: 110,
    },
    {
        id: 'disco-divas',
        name: 'Disco Divas',
        path: '/public/audio/disco-divas.mp3',
        duration: 105,
        bpm: 123,
    },
    {
        id: 'essence-of-light',
        name: 'Essence of Light',
        path: '/public/audio/essence-of-light.mp3',
        duration: 92,
        bpm: 100,
    },
    {
        id: 'for-me',
        name: 'For Me',
        path: '/public/audio/for-me.mp3',
        duration: 112,
        bpm: 97,
    },
    {
        id: 'smoky',
        name: 'Smoky',
        path: '/public/audio/smoky.mp3',
        duration: 94,
        bpm: 100,
    },
    {
        id: 'taka-taka',
        name: 'Taka Taka',
        path: '/public/audio/taka-taka.mp3',
        duration: 99,
        bpm: 108,
    },
    {
        id: 'uncovered',
        name: 'Uncovered',
        path: '/public/audio/uncovered.mp3',
        duration: 110,
        bpm: 80,
    },
    {
        id: 'back-then',
        name: 'Back Then',
        path: '/public/audio/back-then.mp3',
        duration: 184,
        bpm: 90,
    },
    {
        id: 'sweet',
        name: 'Sweet',
        path: '/public/audio/sweet.mp3',
        duration: 189,
        bpm: 121,
    },
    {
        id: 'leaning-off-your-love',
        name: 'Leaning Off Your Love',
        path: '/public/audio/leaning-off-your-love.mp3',
        duration: 247,
        bpm: 109,
    },
    ...UPPBEAT_MUSIC_TRACKS,
];
/** All thirty analysed tracks, available to Claire without service restrictions. */
export const PROFILED_MUSIC_TRACKS = UPPBEAT_MUSIC_TRACKS;
export function getMusicTrackById(id) {
    return SHARED_MUSIC_TRACKS.find((track) => track.id === id);
}
/**
 * Tracks offered on the Music page and in Edit music pickers. Owners can
 * choose any shared track; V2 automatic selection uses the profiled bank.
 */
export const LIBRARY_MUSIC_TRACK_IDS = SHARED_MUSIC_TRACKS.map((track) => track.id);
export const LIBRARY_MUSIC_TRACKS = SHARED_MUSIC_TRACKS.filter((track) => LIBRARY_MUSIC_TRACK_IDS.includes(track.id));
//# sourceMappingURL=music-registry.js.map